"use strict";

exports.__esModule = true;
exports.default = forwardRef;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function forwardRef(renderFn, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    propTypes = _ref.propTypes,
    defaultProps = _ref.defaultProps,
    _ref$allowFallback = _ref.allowFallback,
    allowFallback = _ref$allowFallback === void 0 ? false : _ref$allowFallback,
    _ref$displayName = _ref.displayName,
    displayName = _ref$displayName === void 0 ? renderFn.name || renderFn.displayName : _ref$displayName;
  var render = function render(props, ref) {
    return renderFn(props, ref);
  };
  return Object.assign(_react.default.forwardRef || !allowFallback ? _react.default.forwardRef(render) : function (props) {
    return render(props, null);
  }, {
    displayName: displayName,
    propTypes: propTypes,
    defaultProps: defaultProps
  });
}